import React from 'react'

type WrapperElement = keyof React.JSX.IntrinsicElements

type WrapperProps<T extends WrapperElement = 'div'> = {
  as?: T
} & React.ComponentPropsWithoutRef<T>

export const Wrapper = <T extends WrapperElement = 'div'>({
  children,
  as,
  ...rest
}: WrapperProps<T>): React.ReactElement => {
  const Component = (as ?? 'div') as React.ElementType
  return <Component {...(rest as object)}>{children}</Component>
}
